module.exports = __webpack_public_path__ + "img/etuwan.b40903b3.png";